import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { researchApi } from "../services/research.service";

import {
    RESEARCH_REQUEST,
    researchRequestSuccess,
    researchRequestFailure,
    researchRequest,
    RESEARCH_UPSERT_REQUEST,
    researchUpsertRequestFailure,
    researchUpsertRequestSuccess,
    RESEARCH_UPSERT_REQUEST_SUCCESS,
    RESEARCH_UPSERT_REQUEST_FAILURE
} from "../actions/research.actions";

import {
    siteDataRequest
} from "../actions/sitedata.actions";

import {
    notificationSuccessShow,
    notificationErrorShow
} from "../actions/notification.actions";

export const researchRequestEpic = action$ =>
    action$
        .ofType(RESEARCH_REQUEST)
        .mergeMap((action) =>
            researchApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(researchRequestSuccess(response.research, response.focus, response.states, response.publication, response.people)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(researchRequestFailure(error.responseStatus.message))
                )
        );

export const researchUpsertRequestEpic = action$ =>
    action$
        .ofType(RESEARCH_UPSERT_REQUEST)
        .mergeMap((action) =>
            researchApi
                .upsert(action.research)
                .mergeMap(response => {
                    return concat$(Observable.of(researchUpsertRequestSuccess(response.research)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(researchUpsertRequestFailure(error.responseStatus.message))
                )
        );

export const researchUpsertRequestSuccessEpic = (action$, state$) =>
    action$
        .ofType(RESEARCH_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => researchRequest());

export const researchUpsertRequestSuccessNotificationEpic = (action$, state$) =>
    action$
        .ofType(RESEARCH_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => notificationSuccessShow(action.research.title + " saved"));

export const researchUpsertRequestSuccessSiteDataEpic = (action$, state$) =>
        action$
            .ofType(RESEARCH_UPSERT_REQUEST_SUCCESS)
            .map((action: any) => siteDataRequest());

export const researchUpsertRequestErrorNotificationEpic = (action$, state$) =>
    action$
        .ofType(RESEARCH_UPSERT_REQUEST_FAILURE)
        .map((action: any) => notificationErrorShow("Save failed: " + action.error));


// WEBPACK FOOTER //
// ./src/epics/research.epic.ts